//region block: pre-declaration
//endregion
function unmodifiable(_this__u8e3s4) {
  return _this__u8e3s4;
}
//region block: exports
export {
  unmodifiable as unmodifiable2pi9okt3ceep6,
};
//endregion

//# sourceMappingURL=Collections.web.mjs.map
